import { useEffect, useRef, useState } from "react";

const MIN_CARD_WIDTH = 300; // must match minmax(300px, 1fr) in WorkflowCards
const ROWS_PER_PAGE = 5; // how many full rows to show per page

/**
 * Measures the grid container width and calculates how many columns fit,
 * then returns a `top` value that is always a clean multiple of the column count
 * so pagination never leaves an incomplete last row.
 */
export function useGridColumns() {
  const ref = useRef<HTMLDivElement>(null);
  const [top, setTop] = useState(12); // sensible default (3 cols × 4 rows)

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    function calculate(width: number) {
      const cols = Math.max(1, Math.floor(width / MIN_CARD_WIDTH));
      setTop(cols * ROWS_PER_PAGE);
    }

    // Initial calculation
    calculate(element.getBoundingClientRect().width);

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        calculate(entry.contentRect.width);
      }
    });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return { ref, top };
}
